export enum TypesPermissions {
  PORTAL_CLIENTE = "portal_cliente",
  HOME = "portal_cliente:home:*",
  GOALS_AND_COMMISSIONS = "portal_cliente:goals_and_commissions:*",
  PERFORMANCE_MANAGEMENT = "portal_cliente:performance_management:*",
  CAMPAIGN_METRICS = "portal_cliente:campaign_metrics:*",
  ANNOUCEMENTS = "portal_cliente:announcements:*", // announcements = handouts = Comunicados
  CONTACT = "portal_cliente:contact:*",
  CHANGE_PASSWORD = "portal_cliente:change_password:*",
  SIMULATION = "portal_cliente:simulation:*",
  EMPLOYEE = "portal_cliente:employee:*",
  COLETA = "portal_cliente:coleta:*", // COLETA = SALES = "portal_cliente:sales:*",
  NOZZLES = "portal_cliente:nozzles:*",
  PRODUCT_PRICE = "portal_cliente:product_price:*", // Consultar Preco
  DRIVER_CUSTOMER = "portal_cliente:driver_customer:*",
  ORDER = "portal_cliente:orders:*",
  APPOINTMENTS_TITLE = "portal_cliente:appointments_titles:*",
  APPOINTMENTS_INVOICES = "portal_cliente:appointments_invoices:*",
  DRIVER = "portal_cliente:driver:*",
}

export enum WhatPermission {
  WRITE = "*:WRITE",
}
